import { render, staticRenderFns } from "./PeriodoDePrueba.vue?vue&type=template&id=2dc2d704&"
import script from "./PeriodoDePrueba.vue?vue&type=script&lang=js&"
export * from "./PeriodoDePrueba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports